
window.registerWizzyEvent = (eventName, callback) => {
   window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents[eventName], function (payload = null) {

      let response = payload;
      try {
         response = callback(payload);
      } catch (error) {}

      return response;
   });
}
window.changeWizzyTemplate = (name) => {
   let newDiv = document.getElementById(name + "-new").text;
   let oldDiv = document.getElementById(name)
   oldDiv.text = newDiv;
}
const replaceCutsomTemplateEnable = true;

const removeTrailingZeros = function (number) {
   if (typeof number.replaceAll == 'function') {
      number = number.replaceAll(',', '')
   }
   return parseFloat(number.toString().replace(/(\.\d*?[1-9])0+$/, '$1'));
}
const replaceCustomTemplate = () => {
   //if (!replaceCutsomTemplateEnable) return;
   // let templatesToReplace = [
   //     'wizzy-autocomplete-topproducts',
   //     'wizzy-search-results-product',
   //     'wizzy-search-results',
   //     'wizzy-search-wrapper',
   //     'wizzy-search-summary'
   // ];
   // templatesToReplace.forEach((t) => {
   //     window.changeWizzyTemplate(t)
   // });
}
const isWizzyMobile = window.screen.width < 768;


const rootStyleVar = document.querySelector(':root').style;

const setWizzyInputWidthAndTop = function () {
   let targetInputEle = $('header .de-SingleInputForm .de-SingleInputForm-input');
   let inputWidth = targetInputEle.width() + 'px';
   let inputleft = targetInputEle.offset().left + 'px';
   rootStyleVar.setProperty('--wizzyInputLeft', inputleft);
   rootStyleVar.setProperty('--wizzyInputWidth', inputWidth);
}
const setWizzyInputSticky = function (condition) {
   let headerAutocomplate = $('.wizzy-autocomplete-wrapper');
   if (condition) {
      // headerAutocomplate.addClass('wizzy-header-fixed');
   } else {
      // headerAutocomplate.removeClass('wizzy-header-fixed');
   }
}
window.onWizzyScriptLoaded = function () {
   $('[name="q"]').attr('autocomplete', 'off')
   setWizzyInputWidthAndTop();
   addEventListener("scroll", (event) => {


      setWizzyInputSticky(window.scrollY > 56);

      setWizzyInputWidthAndTop();
   });
   // let targetInputEle = $('header .de-SingleInputForm .de-SingleInputForm-input');
   // let inputWidth = targetInputEle.width() + 'px';
   // let inputleft = targetInputEle.offset().left + 'px';
   // rootStyleVar.setProperty('--wizzyInputLeft', inputleft);
   // rootStyleVar.setProperty('--wizzyInputWidth', inputWidth);
   const preLoadImg = (url) => {
      var img = new Image();
      img.src = url;
   }

   let headerId = "navigation-2_0";

   let headerObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutationRecord) {
         setWizzyInputWidthAndTop();
         let headerEle = $(mutationRecord.target);
         let headerAutocomplate = $('.wizzy-autocomplete-wrapper');

         if (headerEle.hasClass('headerFixed')) {
            // headerAutocomplate.addClass('wizzy-header-fixed');
         } else {
            // headerAutocomplate.removeClass('wizzy-header-fixed');
         }
      });
   });

   let headerTarget = document.getElementById(headerId);
   headerObserver.observe(headerTarget, {
      attributes: true,
      attributeFilter: ['class']
   });

   const setValueFromAttributes = (key, setKey, product) => {
      let attributes = product?.attributes;
      let foundAttributes = attributes.filter(x => x.id == key);
      if (foundAttributes?.length) {
         foundAttributes = foundAttributes[0];
         product[setKey] = foundAttributes['values'][0]['value'][0];
      }
   }

   const customPriceWithCurrency = () => {
      return (price, render) => {
         let priceStr = [];

         if (window.wizzyConfig.store.currency.symbolOrder == 'before') {
            priceStr.push(window.wizzyConfig.store.currency.symbol);
         }

         priceStr.push(price);
         if (window.wizzyConfig.store.currency.symbolOrder == 'after') {
            priceStr.push(window.wizzyConfig.store.currency.symbol);
         }
         return render(priceStr.join(' '));
      };
   };
   const initSwatch = () => {
      let allSelectedSwatches = $('.slick-track .product-item-swatch-item.is-wizzy-swatch-selected');

      $('.slick-track .product-item-swatch-item.is-wizzy-swatch-selected').each((index, ele) => {

         let cEle = $(ele);

         let parentEle = cEle.parents('.slick-track');
         let collectionProductEle = parentEle.parents('.collectionProduct-variants');
         let selectedVariant = collectionProductEle.find('[data-wizzy-index].is-wizzy-swatch-selected')
         let currentIndex = parseInt(selectedVariant.attr('data-wizzy-index'));
         let swatches = parentEle.find('.product-item-swatch-item');
         let nextIndex = currentIndex + 1;
         collectionProductEle.attr('data-current-index', currentIndex);
         collectionProductEle.attr('data-next-index', nextIndex);
         collectionProductEle.attr('data-total-swatch', swatches.length);
      })
   }

   $('[action="/search"]').attr('action', '/pages/search');
   $('body').on('click', '.wizzy-search-results-wrapper .slick-next.slick-arrow', (e) => {
      e.stopImmediatePropagation();
      e.preventDefault();
      let targetEle = $(e.target);
      let parentEle = targetEle.parents('.collectionProduct-variants');
      let selctedSwatch = parentEle.find('.is-wizzy-swatch-selected');
      let currentIndex = selctedSwatch.attr('data-wizzy-index');
      let nextIndex = parseInt(currentIndex) + parseInt(1);
      let trackEle = parentEle.find('.slick-track .product-item-swatch-item');
      let nextTarckEle = parentEle.find('.slick-track .product-item-swatch-item[data-wizzy-index="' + nextIndex + '"]');
      if (nextTarckEle.length) {
         let toscroll = 0;
         nextTarckEle.click();
      }


   });
   $('body').on('click', '.wizzy-search-results-wrapper .slick-prev.slick-arrow', (e) => {
      e.stopImmediatePropagation();
      e.preventDefault();
      let targetEle = $(e.target);
      let parentEle = targetEle.parents('.collectionProduct-variants');
      let selctedSwatch = parentEle.find('.is-wizzy-swatch-selected');
      let currentIndex = selctedSwatch.attr('data-wizzy-index');
      let nextIndex = parseInt(currentIndex) - parseInt(1);
      parentEle.attr('data-next-index', nextIndex);
      parentEle.attr('data-current-index', currentIndex);
      let trackEle = parentEle.find('.slick-track .product-item-swatch-item');
      let nextTarckEle = parentEle.find('.slick-track .product-item-swatch-item[data-wizzy-index="' + nextIndex + '"]');
      if (nextTarckEle.length) {
         nextTarckEle.click();
      }


   });


   replaceCustomTemplate();

   $(document).on('scroll', function (e) {
      let headerEle = $('#navigation-2_0');
      let headerAutocomplate = $('body');

      if (headerEle.hasClass('headerFixed')) {
         headerAutocomplate.addClass('wizzy-header-fixed');
      } else {
         headerAutocomplate.removeClass('wizzy-header-fixed');
      }
   });

   window.registerWizzyEvent('BEFORE_AUTOCOMPLETE_EXECUTED', (payload) => {
      let headerEle = $('#navigation-2_0');
      let headerAutocomplate = $('body');

      if (headerEle.hasClass('headerFixed')) {
         headerAutocomplate.addClass('wizzy-header-fixed');
      } else {
         headerAutocomplate.removeClass('wizzy-header-fixed');
      }

      return payload;
   });

   let cachedFooter = $('.js-de-SiteFooter').html();
   window.registerWizzyEvent('BEFORE_LAZY_INIT', (payload) => {
      payload.common.lazyDOMConfig.contentDOMIdentifiers = ['.de-PageWrap-main'];
      payload["filters"]["configs"]["keepOpenedInMobileAfterApply"] = true;

      payload["search"]["view"]["templates"]["literals"]["emptySearchResultPageTitle"] = "Nous n'avons trouvé aucune correspondance !";

      // payload.search.configs.facets.configs=[
      //   {label: 'Gender', key: 'product_gender_tag', position: 'left', order: 1},
      //   {label: 'Size', key: 'product_sizes', position: 'left', order: 2},
      //   {label: 'Brand', key: 'product_vendor', position: 'left', order: 3}
      // ]

      payload.store.currency.symbolOrder = 'before';
      window.wizzyConfig.store.currency.symbol = '$';
      return payload;
   });
   $.fn.isInViewport = function () {
      var elementTop = $(this).offset().top;
      var elementBottom = elementTop + $(this).outerHeight();

      var viewportTop = $(window).scrollTop();
      var viewportBottom = viewportTop + $(window).height();

      return elementBottom > viewportTop && elementTop < viewportBottom;
   };
   const sizeOrder = [
      '2XS', '2XS', 'XS', 'XS', 'S', 'M', 'L', 'XL', '2XL', '3XL'
   ];
   window.registerWizzyEvent('VIEW_RENDERED', (payload) => {
      if (cachedFooter && (payload.data.api == 'search' || payload.data.api == 'filter')) {
         $('.wizzy-main-content').append('<footer class="site-footer small--text-center js-de-SiteFooter" role="contentinfo">' + cachedFooter + '</footer>');
         cachedFooter = null;
      }
      if (payload.data.api == 'search' || payload.data.api == 'variation' || payload.data.api == 'filter') {
         initSwatch();
      }


      if (payload.data.api == 'filter') {
         let filterTagCount = $('.wizzy-selected-facet-list-item ').length;
         let searchWrapperEle = $('.wizzy-search-results-container.collection-products-wrapper');
         let searchWrapperListEle = searchWrapperEle.find('.wizzy-selected-facet-list');
         let heightOfSummry = searchWrapperListEle.height();
         if (heightOfSummry > 55) {
            heightOfSummry = heightOfSummry - 53;
            searchWrapperEle.addClass('wzzyy-higher-order-tags');
         } else {
            heightOfSummry = 20;
            searchWrapperEle.removeClass('wzzyy-higher-order-tags');
         }

         $('.wizzy-search-wrapper.has-left-facets .wizzy-search-results-wrapper .wizzy-search-results-container.wzzyy-higher-order-tags .wizzy-search-results').css('padding-top', heightOfSummry + 'px');
      }
      return payload;
   });

   window.registerWizzyEvent('BEFORE_RENDER_RESULTS', (payload) => {

      let allFacet = payload.response.payload.facets;
      allFacet.forEach((facet) => {
         if (facet.key == "colors") {
            let facetData = facet.data;
            facetData.forEach((facetKey) => {
               if (typeof facetKey['data'] !== "undefined") {
                  delete facetKey['data'];
               }
            });
         }
         if (facet.key == "sizes") {
            let facetData = facet.data;
            facetData.forEach((facetKey) => {
               let facetKeyRaw = facetKey.key.trim();
               let facetKeyValue = facetKeyRaw.toLowerCase();
               let facetKeyExtra = [facetKeyValue, '-'].join(' ');
               let facetOrder = sizeOrder.findIndex(x => facetKeyValue == x.trim().toLowerCase() || facetKeyValue.includes([x.trim().toLowerCase(), '-'].join(' ')) || facetKeyValue.includes([x.trim().toLowerCase(), '/'].join('')));
               if (facetOrder === -1) {
                  facetOrder = -1;
                  facetKey.order = facetOrder;
               } else {
                  facetOrder = sizeOrder.length - facetOrder;
               }
               facetKey.order = facetOrder;
            });

            facetData.sort((a, b) => {
               return ((a.order > b.order) ? -1 : ((a.order < b.order) ? 1 : 0));
            });
         }
      })

      return payload;
   });

   window.registerWizzyEvent("BEFORE_INIT", function (data) {
      window.wizzyConfig.store.currency.symbol = '$';
      return data;
   });

   window.registerWizzyEvent("VIEW_RENDERED", function (data) {
      if (isWizzyMobile) {
         document.querySelectorAll('.collectionProduct-variants.variants-carousel.slick-initialized.slick-slider').forEach(parent => {
            const currentIndex = parseInt(parent.getAttribute('data-current-index'), 10) || 0;
            const slider = parent.querySelector('.slick-track');
            if (slider && currentIndex > 2) {
               slider.scrollLeft = currentIndex * 20;
            }
         });
      }


      // // Initial run
      // transformFacetLabels();

      // // Watch for changes to the DOM (like when filters update)
      // const observer = new MutationObserver(() => {
      //    transformFacetLabels();
      // });

      // observer.observe(document.body, {
      //    childList: true,
      //    subtree: true,
      // });
      return data;
   });
   const transformFacetLabels = () => {
      document.querySelectorAll('.facet-item-label-value')?.forEach((el) => {
         el.textContent = capitalizeText(el.textContent);
      });
   };

   window.registerWizzyEvent("PRODUCTS_RESULTS_RENDERED", function (data) {
      if (window.innerWidth < 768)
         for (var elements = document.getElementsByClassName("wizzy-filters-facet-block"), i = 0; i < elements.length; i++) {
            var element = elements[i];
            element.addEventListener("click", function () {
               this.classList.toggle("collapsed")
            })
         }
      document.querySelectorAll(".de-PageWrap-main .shopify-section").forEach(element => {
         element.remove();
      });

      return data;
   });

   window.registerWizzyEvent("AFTER_PRODUCTS_TRANSFORMED",
      function (products) {
         products.forEach((product) => {
            product.categoriesName = product.categories?.map(x => x.id).join(',');
            product.isEcoDesign = product.categories?.filter(x => x.id == 'eco-design').length > 0;
            let allTags = product.attributes?.filter(x => x.id == "product_tags");
            if (allTags?.length) {
               allTags = allTags[0];
               let allCompbinedTags = [...allTags.values[0].value];
               allCompbinedTags = allCompbinedTags[0].split(',');
               product.isInnovation = allCompbinedTags.filter(x => x.trim() == 'Innovation').length > 0;
               product.isNewRealease = allCompbinedTags.filter(x => x.trim() == 'LifeStage:2').length > 0;
               product.isEco = allCompbinedTags.filter(x => x.trim() == 'ECODESIGN').length > 0;
               product.isSameDay = allCompbinedTags.filter(x => x.trim() == 'SAME_DAY_DELIVERY').length > 0;


               product.isPersonalizeMe = allCompbinedTags.filter(x => x.trim() == 'personalize-me').length > 0;
               product.isEndSeries = allCompbinedTags.filter(x => x.trim() == 'LifeStage:1' || x.trim() == 'LifeStage:2' || x.trim() == 'LifeStage:4').length < 1;


               if (product.isEcoDesign) {
                  product.isEndSeries = false;
               }
               if (product.isEcoDesign) {

               }
            }

            let attributes = product?.attributes;
            let pricingArray = []
            product?.attributes?.forEach((att) => {
               if (att.id === "product_variant_prices") {
                  let prices = att?.values;
                  prices.forEach((pr) => {
                     pricingArray.push(pr.value[0])
                  })
               }
            })

            maxPrice = Math.max(...pricingArray);
            minPrice = Math.min(...pricingArray);
            if (minPrice < maxPrice) {
               product.sellingPrice = `${minPrice} - $ ${maxPrice}`
            } else {
               product.sellingPrice = product.sellingPrice.replaceAll(',', '');
               product.sellingPrice = removeTrailingZeros(product.sellingPrice);
            }

         // product.discountedPrice = Math.round(product.sellingPrice - product.sellingPrice * 0.15);
            preLoadImg(product.mainImage);

            setValueFromAttributes('product_handle', 'handle', product);
            setValueFromAttributes('product_ratings_count_reviews', 'totalReview', product);
            setValueFromAttributes('product_product_rating_reviews', 'reviews', product);
            if (product.hasOwnProperty('reviews')) {
               let loopTime = 6;
               let ratting = Math.round(product.reviews);
               product.starRatting = [];
               for (let i = 1; i < loopTime; i++) {
                  if (i > ratting) {
                     product.starRatting.push({
                        class: "de-gray-star"
                     });
                  } else {
                     product.starRatting.push({
                        class: "de-yellow-star"
                     });
                  }

               }

            }
            let foundColorSwatch = (product.swatches) ? product.swatches.filter(x => x.key == 'colors') : [];
            if (foundColorSwatch.length) {
               foundColorSwatch = foundColorSwatch[0];
               product.isColorSwatch = foundColorSwatch.values.length > 1 &&
                  foundColorSwatch.values.filter(v => v.isVisualSwatch).length;


               if (product.isColorSwatch) {
                  let cIndex = 1;
                  //     foundColorSwatch.values=foundColorSwatch.values.sort((a, b)=>{
                  //       return ((a.isSelected> b.isSelected) ? -1 : ((a.isSelected < b.isSelected) ? 1 : 0));
                  // });
                  foundColorSwatch.values.forEach((color) => {
                     color.index = cIndex;
                     cIndex++;
                     if (color.isVisualSwatch) {
                        preLoadImg(color.swatchValue);
                     }
                  });


               }

            } else {
               product.isColorSwatch = false;
            }
            // product.isColorSwatch=product.hasOwnProperty('colors') &&
            // (typeof product.colors == 'array' || typeof product.colors == 'object') && product['colors'].length
            //   && product.colors.filter(v=>v.value!="Default" && v.hasOwnProperty('swatch')).length > 1
            //   ;

            product.priceWithCurrency = customPriceWithCurrency;
            if (product.inStock === false) {
               product.outOfStock = true;
            }
            if (product.discountPercentage != 0) {
               if (product.sellingPrice < product.price) {
                  product.onSale = true;
               }
            }
            // Remove decimal part from prices
            if (
               typeof product.price !== "undefined" &&
               product.price &&
               product.price.toString().includes(".")
            ) {
               product.price = product.price.toString().split(".")[0];
            }

            if (
               typeof product.sellingPrice !== "undefined" &&
               product.sellingPrice &&
               product.sellingPrice.toString().includes(".")
            ) {
               product.sellingPrice = product.sellingPrice.toString().split(".")[0];
            }

         });

         return products;
      }
   );
   const capitalizeText = (str) => {
      return str;
      if (!str || typeof str !== 'string') return ''; // <-- safety check

      return str
         .toLowerCase()
         .trim()
         .split(/\s+/)
         .map((word) =>
            word.includes('/') ?
            word
            .split('/')
            .map(w => w.charAt(0).toUpperCase() + w.slice(1))
            .join('/') :
            word.charAt(0).toUpperCase() + word.slice(1)
         )
         .join(' ');
   };
   window.registerWizzyEvent('PRODUCTS_CACHED_RESULTS_RENDERED', (payload) => {
      document.getElementsByTagName("body")[0].classList.add("wizzy-search-results-rendered")
      return payload;
   });

}; 
